<template>
  <v-content>
    <Nav/>

    <Hero
      :boldText="chosenBoldText"
      :heroText="chosenHeroText"
      :subText="chosenSubText"
      buttonText="Check it out"
      buttonLink="/blog"
    />
    <Featured/>
    <About/>
    <Extra/>

    <Footer/>
  </v-content>
</template>

<script>
import Nav from '../components/global/Nav';
import Footer from '../components/global/Footer';
import Hero from '../components/partials/Hero';
import Featured from '../components/featured';
import Extra from '../components/extra';
import About from '../components/about';

// TODO: add randomized messages on load

export default {
  name: 'home',

  components: {
    Nav,
    Footer,
    Hero,
    Featured,
    Extra,
    About,
  },

  props: {

  },

  data() {
    return {
      chosenBoldText:"",
      chosenHeroText:"",
      chosenSubText:"",
      randomHero: {
        boldText: [
          "So glad you're here.",
          "Welcome!",
          "Bienvenue!",
          "Bienvenido!",
        ],
        heroText: [
          " This is GoocH.me, my blog about nerd stuff. Enjoy.",
          " This is GoocH.me, feel free to look around."
        ],
        subText: [
          "Clearly, I am not a designer. I hope we can move past that.",
          "Feel free to leave me a message.",
          "This message is random! How crazy, right?",
          "Loving built with vue.js",
          "Currently not updated very often, but I'm working on it."
        ]
      }
    }
  },

  created: function() {
    // if (this.$cookies.get("user_session") == null) {
    //   this.$router.push('login');
    // }
    this.randomizeHero()
  },

  methods: {
    randomizeHero() {
      this.chosenBoldText = this.randomHero.boldText[this.getRandomInt(this.randomHero.boldText.length)]
      this.chosenHeroText = this.randomHero.heroText[this.getRandomInt(this.randomHero.heroText.length)]
      this.chosenSubText = this.randomHero.subText[this.getRandomInt(this.randomHero.subText.length)]
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    }

  }
};
</script>